import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

interface DeletionRequestResponse {
  success: boolean;
  requestId: string;
  message: string;
}

export const submitDeletionRequest = async (): Promise<DeletionRequestResponse> => {
  try {
    const submitRequest = httpsCallable<any, DeletionRequestResponse>(
      functions,
      'privacy_submitDeletionRequest'
    );
    
    const result = await submitRequest({});
    return result.data;
  } catch (error: any) {
    console.error('Failed to submit deletion request:', error);
    throw new Error(error.message || 'Failed to submit deletion request');
  }
};